import { render } from "./babekyaaaaaa.vue?vue&type=template&id=66df4f9c"
import script from "./babekyaaaaaa.vue?vue&type=script&lang=js"
export * from "./babekyaaaaaa.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__